exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".home {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -ms-flex-pack: center;\n  justify-content: center;\n  -ms-flex-align: center;\n  align-items: center;\n  min-height: 100vh; }\n  .home__description {\n    font-weight: bold;\n    color: #777; }\n\n.qr-code {\n  width: 300px;\n  height: 300px;\n  opacity: .6; }\n  .qr-code img {\n    width: 100%;\n    height: 100%; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/pages/HOME_PAGE/index.scss
// module id = 257
// module chunks = 0